import React from 'react';
import connectStatic from 'app/utils/connectStatic';
import t from 'app/utils/translate';
import Page from 'app/containers/parts/Page';
import StaticContent from 'app/components/static/StaticContent';

const TermsAndConditionsContent = connectStatic({
  index: 'terms',
  layout: 'complex',
  title: t('Terms and Conditions'),
})(StaticContent);

function TermsAndConditions() {
  return (
    <Page>
      <TermsAndConditionsContent />
    </Page>
  );
}

export default TermsAndConditions;
